<!-- 文字向上翻滚的组件；TODO 实现一个不依赖于 el-carsousel 的 flip upper 组件 -->
<template>
    <!-- height 属性非常的关键，限制 carousel 不要太高，这样就会形成一个滚动字幕的展现形式 -->
    <el-carousel height="18px"
                 :style="{'width': width+'px', 'font-size': fontSize + 'px', 'line-height': lineHeight + 'px'}"
                 direction="vertical"
                 :autoplay="true"
                 :interval="4000">
        <el-carousel-item v-for="t in texts" :key="t">
            <div>
                <span :class="fontClass" :style="{'color': fontColor}">{{t}}</span>
            </div>
        </el-carousel-item>
    </el-carousel>
</template>

<script>
    export default {
        name: "Flipupper",
        props: {
            texts: {
                type: Array,
                default: []
            },
            width: {
                type: Number,
                default: '300'
            },
            fontSize: {
                type: Number,
                default: 14
            },
            fontClass: {
                type: String,
                default: ''
            },
            fontColor: null,
            lineHeight: {
                type: Number,
                default: 14
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/Flipupper.vue